
      export default {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"xmlns":"http://www.w3.org/2000/svg","viewBox":"0 0 32 32"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M12 3c2.202 0 3.791 1.007 4.531 2.313.026-.041.034-.084.063-.125C17.047 4.547 17.909 4 19 4v2c-.453 0-.588.111-.719.281 3.845.921 6.812 4.105 7.563 8.063C27.037 14.741 28 15.681 28 17c0 1.365-1.024 2.33-2.281 2.688-.816 4.701-4.82 8.313-9.719 8.313s-8.903-3.611-9.719-8.313C5.024 19.331 4 18.365 4 17s1.024-2.33 2.281-2.688c.741-4.271 4.122-7.637 8.406-8.219-.39-.574-1.192-1.094-2.688-1.094v-2zm4 5c-4.093 0-7.461 3.121-7.906 7.125L8 16H7c-.555 0-1 .445-1 1s.445 1 1 1h1l.094.875C8.539 22.879 11.907 26 16 26s7.461-3.121 7.906-7.125L24 18h1c.555 0 1-.445 1-1s-.445-1-1-1h-.875L24 15.125C23.464 11.106 20.093 8 16 8zm-3.5 8a1.5 1.5 0 11-.001 3.001A1.5 1.5 0 0112.5 16zm7 0a1.5 1.5 0 11-.001 3.001A1.5 1.5 0 0119.5 16z"}})])
          )
        }
      }
    